import { render, staticRenderFns } from "./CommandPane.vue?vue&type=template&id=b661552c"
import script from "./CommandPane.vue?vue&type=script&lang=js"
export * from "./CommandPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports